import React from "react";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import { NEWS_ITEMS } from "./newsData";

const News = () => {
  return (
    <div>
      <Helmet>
        <title>News | MSB Association UK</title>
        <meta name="description" content="Latest news and updates from the MSB Association UK." />
        <meta property="og:title" content="News | MSB Association UK" />
        <meta property="og:description" content="Latest news and updates from the MSB Association UK." />
        <meta property="og:image" content="/assets/images/logo.png" />
      </Helmet>
      <main className="page_content">
        <section className="page_header text-center section_decoration overflow-hidden" style={{ background: "#333" }}>
          <div className="container">
            <h1 className="page_title text-white">News</h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="active">
                <a href="#!">News</a>
              </li>
            </ul>
          </div>
        </section>

        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="row justify-content-start">
              {NEWS_ITEMS.map((item) => (
                <div key={item.id} className="col-md-6 col-lg-6 col-xl-4 mix trending featured mb-2" data-bound>
                  <div className="course-single-item">
                    <div className="d-block course-single-item-img">
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="course-single-item-content-bg">
                      <div className="course-single-item-content">
                        <h3>
                          <NavLink to={`/news/${item.slug}`}>{item.title}</NavLink>
                        </h3>
                        {item.date && (
                          <>
                            <i className="fa-regular fa-calendar-days"></i>{" "}
                            {new Date(item.date).toLocaleDateString("en-GB", {
                              year: "numeric",
                              month: "short",
                              day: "2-digit",
                            })}
                          </>
                        )}
                        {item.excerpt && <p className="mt-2">{item.excerpt}</p>}
                      </div>
                      <div className="d-flex justify-content-center course-single-item-price-cart">
                        <NavLink to={`/news/${item.slug}`} className="btn btn-primary btn-hover-secondary">
                          Read More
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default News;


